import React from "react"
import { Fab as MuiFab, FabProps } from "@material-ui/core"

const Fab: React.FC<FabProps> = props => <MuiFab disableRipple={true} {...props} />
export default Fab
